import { DataOutputStream, FileSystem } from './java/DataStream';

export class Stats {
  private static readonly FILE = 'dotch_stats.dat';

  // attempts[difficulty] and highScores[difficulty]
  private static attempts: number[] = new Array<number>(3).fill(0); // 0=normal, 1=hard, 2=insane
  private static highScores: number[] = new Array<number>(3).fill(0);
  private static currentAttempt = 0;

  static init(): void {
    Stats.load();
  }

  static newAttempt(difficulty: number): void {
    if (difficulty >= 0 && difficulty < 3) {
      Stats.attempts[difficulty]++;
      Stats.currentAttempt = Stats.attempts[difficulty];
      Stats.save();
    }
  }

  static getCurrentAttempt(): number {
    return Stats.currentAttempt;
  }

  static getAttempts(difficulty: number): number {
    if (difficulty >= 0 && difficulty < 3) return Stats.attempts[difficulty];
    return 0;
  }

  static getHighScore(difficulty: number): number {
    if (difficulty >= 0 && difficulty < 3) return Stats.highScores[difficulty];
    return 0;
  }

  static submitScore(difficulty: number, score: number): boolean {
    if (difficulty >= 0 && difficulty < 3 && score > Stats.highScores[difficulty]) {
      Stats.highScores[difficulty] = score;
      Stats.save();
      return true;
    }
    return false;
  }

  static resetHighScores(): void {
    Stats.highScores = new Array<number>(3).fill(0);
    Stats.save();
  }

  static resetAll(): void {
    Stats.attempts = new Array<number>(3).fill(0);
    Stats.highScores = new Array<number>(3).fill(0);
    Stats.currentAttempt = 0;
    Stats.save();
  }

  private static save(): void {
    try {
      const out = new DataOutputStream(Stats.FILE);
      for (let i = 0; i < 3; i++) out.writeInt(Stats.attempts[i]);
      for (let i = 0; i < 3; i++) out.writeInt(Stats.highScores[i]);
      out.close();
    } catch {
      // Silent fail — stats are nice-to-have
    }
  }

  private static load(): void {
    const in_ = FileSystem.open(Stats.FILE);
    if (in_ === null) return;
    try {
      for (let i = 0; i < 3; i++) Stats.attempts[i] = in_.readInt();
      for (let i = 0; i < 3; i++) Stats.highScores[i] = in_.readInt();
      in_.close();
    } catch {
      // Corrupted or old format — reset
      Stats.attempts = new Array<number>(3).fill(0);
      Stats.highScores = new Array<number>(3).fill(0);
    }
  }
}
